import { useDelayedText } from '@src/components/sco/TypingText'
import { hourSeed, seededShuffle } from '@src/lib/seededShuffle'
import { useMemo, useState } from 'react'
import { useInterval } from 'react-use'

export const useRotatingPlaceholder = (
  options: Array<string>,
  config?: {
    shuffle?: boolean
    interval?: number
    typingTextDelayInMs?: number
    value?: any
  }
) => {
  const [placeholderIndex, setPlaceholderIndex] = useState<number>(0)

  const placeholders = useMemo(() => {
    if (config?.shuffle) {
      return seededShuffle(options || ['Placeholder...'], hourSeed())
    } else {
      return options || ['Placeholder...']
    }
  }, [JSON.stringify(options)])

  const placeholder = useDelayedText(placeholders[placeholderIndex], config?.typingTextDelayInMs)

  useInterval(() => {
    if (config?.value) {
      return
    }
    if (placeholderIndex === placeholders.length - 1) {
      setPlaceholderIndex(0)
    } else {
      setPlaceholderIndex(placeholderIndex + 1)
    }
  }, config?.interval || 3000)

  return placeholder
}
